<template>
  <page>
    <v-card>
      <v-flex xs12>
        <message :messages="messages"></message>
      </v-flex>
      <v-card-title>
        <div class="headline">Engine Make Listing</div>
        <v-spacer></v-spacer>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-card-title>
      <v-data-table :headers="headers" :items="items" :search="search" :rows-per-page-items="itemsPerPage" :pagination.sync="pagination" item-key="vesEngMake" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <span slot="activator">
              {{ props.header.text }}
            </span>
            <span>
              {{ props.header.text }}
            </span>
          </v-tooltip>
        </template>
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.vesEngMake }}</td>
          <td class="text-xs-left">{{ formatTextLength(props.item.vesEngMakeDesc) }}</td>
          <td class="text-xs-right">
            <table-action :rowData="props" review @review="doReview(props.item.vesEngMake)" remove @remove="doPromptRemove(props.item)"></table-action>
          </td>
        </template>
      </v-data-table>
    </v-card>
    <v-btn color="primary" dark class="mb-2" @click="doNew">
      New Engine Make
      <v-icon right>mdi-plus</v-icon>
    </v-btn>
    <v-dialog v-model="engMakeDialog" width="800px" lazy persistent v-if="checkAccess(['vesselReview'])">
      <VesEngMakeDialog :vesEngMakeForm="vesEngMakeForm" @close="doClose" :newEngMake="newEngMake"></VesEngMakeDialog>
    </v-dialog>
    <confirm v-model="promptRemove" @ok="doRemove">
      Are you sure that you want to delete the selected Vessel Engine Make? ({{deleteVesEngMake}})
    </confirm>
  </page>
</template>

<script>
import { mapGetters } from 'vuex'
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import VesEngMakeDialog from './vesEngMakeDialog'
import { expandURI } from '@/utils/ajax'

export default {
  data() {
    return {
      headers: [
        { text: 'Engine Make', value: 'vesEngMake' },
        { text: 'Engine Make Description', value: 'vesEngMakeDesc' },
        TableConst.tableActionHeader
      ],
      vesEngMakeForm: {
        vesEngMake: undefined,
        vesEngMakeDesc: undefined
      },
      engMakeDialog: undefined,
      newEngMake: undefined,
      promptRemove: false,
      selectedVesEngMake: undefined,
      deleteVesEngMake: ''
    }
  },
  created() {
    this.doInit()
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    vesMenu() {
      return this.$store.state.vessel.menu
    }
  },
  methods: {
    async doInit() {
      this.loading = true
      const apiURL = this.vesMenu.getVslEngMakes
      if (apiURL) {
        try {
          const result = await this.$http.get(apiURL)
          if (result) {
            const { data } = result.data
            this.$store.commit('VESSEL_ENGMAKELIST', data)
            this.items = []
            data.map((vslEngMake) => {
              const convertVslEngMake = {
                vesEngMake: vslEngMake.vesEngMake,
                vesEngMakeDesc: vslEngMake.vesEngMakeDesc
              }
              this.items.push(convertVslEngMake)
            })
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fullMessage(data)
          }
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
      this.loading = false
    },
    async doReview(vesEngMake) {
      const apiURI = this.vesMenu.getVslEngMake
      const expand = {
        vesEngMake
      }
      if (apiURI) {
        const result = await this.$http.get(expandURI(apiURI, expand))
        const { data } = result.data
        if (result.data) {
          this.vesEngMakeForm.vesEngMake = data.vesEngMake.vesEngMake
          this.vesEngMakeForm.vesEngMakeDesc = data.vesEngMake.vesEngMakeDesc
        }
        this.engMakeDialog = true
      }
    },
    doNew() {
      this.$validator.reset()
      this.engMakeDialog = true
      this.newEngMake = true
    },
    doClose() {
      this.engMakeDialog = false
      this.newEngMake = false
      this.$validator.reset()
      this.doInit()
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedVesEngMake = data
        this.deleteVesEngMake = data.vesEngMake + ' - ' + data.vesEngMakeDesc
      }
    },
    async doRemove() {
      const apiURI = this.vesMenu.deleteVslEngMake
      if (apiURI) {
        const expand = this.selectedVesEngMake
        this.$http.post(apiURI, expand).then(result => {
          const data = result.data
          this.notify(data)
          this.doInit()
        }).catch(err => {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        })
      }
    }
  },
  components: {
    VesEngMakeDialog
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style>
</style>
